module.exports = __webpack_public_path__ + "static/introductory-f75a8d71b24e4757fcd43c4c01f68475.svg";